import type {EmploymentsResponse} from '@rocket-ui/lk-api';
import {mapSelfEmploymentProfileConnectionState} from 'features/registration/model/employmentConnectionStates';

/** Профиль из `selfEmploymentProfiles` подключён: плитка в состоянии «Подключён». */
export function isSelfEmploymentProviderConnected(
	data: Pick<EmploymentsResponse, 'selfEmploymentProfiles'> | null | undefined,
	provider: string,
): boolean {
	const requiredProvider = provider.trim();

	if (!requiredProvider) return true;

	const profile = data?.selfEmploymentProfiles?.find((item) => item.provider === requiredProvider);

	if (!profile) return false;

	const state = mapSelfEmploymentProfileConnectionState(profile);

	return state === 'connected' || state === 'current';
}
